import { React, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from "moment";  
import { useNavigate,Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { faL } from "@fortawesome/free-solid-svg-icons";
/*
const raceItems = [
  {
    time: "11:20",
    date: "23-02",
    venue: "Venue (countryCode)",
  },
  {
    time: "11:20",
    date: "23-02",
    venue: "Venue (countryCode)",
  },
  {
    time: "11:20",
    date: "23-02",
    venue: "Venue (countryCode)",
  },
  {
    time: "11:20",
    date: "23-02",
    venue: "Venue (countryCode)",
  },
  {
    time: "11:20",
    date: "23-02",
    venue: "Venue (countryCode)",
  },
  // Repeat or add real data as needed
];*/

export default function RaceSlider({
  raceTitle,
  raceIcon,
  gameType,
  eventList
}) {
  let slidesToShow = 7;
  let slidesToScroll = 4;
  if (isMobile) {
    slidesToShow = 3;
    slidesToScroll = 3;
  }
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    variableWidth: false,
    centerMode: false,
    //slidesToShow: 7,
    //slidesToScroll: 4,
    autoplay: false,
    responsive: [
      { breakpoint: 1000, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 3 } },
      { breakpoint: 0, settings: { slidesToShow: 3 } }
    ]
  };

  const [raceItems, setActiveEventslist] = useState([]);

  if (gameType === "4") {
    if (
      eventList !== null &&
      eventList !== undefined &&
      eventList.horse !== undefined &&
      eventList.horse.length > 0
    ) {
      let eventAddCounter = 0;
      let resultEventList = eventList.horse;

      for (let i = 0; i < resultEventList.length; i++) {
        //if (eventAddCounter < 20) {
        raceItems.push(resultEventList[i]);
        eventAddCounter++;
        //}
      }
    }
  } else {
    if (
      eventList !== null &&
      eventList !== undefined &&
      eventList.grey !== undefined &&
      eventList.grey.length > 0
    ) {
      let eventAddCounter = 0;
      if (eventAddCounter < 20) {
        let resultEventList = eventList.grey;
        for (let i = 0; i < resultEventList.length; i++) {
          if (eventAddCounter < 20) {
            raceItems.push(resultEventList[i]);
            eventAddCounter++;
          }
        }
      }
    }
  }

  return (
    <div className="race-cards-wrapper-row">
      <style>{` 
  .slick-next:before, .slick-prev:before {
    color:#000; 
} 
`}</style>

      <style>{` 

@media (max-width: 768px) {
  .slick-slide {
    width: 95px !important;
  }

  
}
  

`}</style>

      <div
        className="race-cards-wrapper-title"
        style={{ paddingBottom: "0px", paddingTop: "0px" }}
      >
        <img
          className="imghorse"
          src={`assets/images/${raceIcon}.svg`}
          alt={raceTitle}
        />{" "}
        {raceTitle}
      </div>
      <div
        className="race-cards-slider-wrapper"
        style={{ background: "#3d6b8b", color: "white" }}
      >
        <div className="race-cards-slider-wrapper-row">
          <Slider {...settings}>
            {raceItems.map((item, idx) => (
              <div className="item" key={idx}>
                <div className="race-cards-item-row">
                  <Link to={`/market/${item.mid}`}>
                    <div className="chkmobile" style={{ paddingBottom: "0px" }}>
                      <table style={{ width: "100%", lineHeight: "20px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "center"
                              }}
                            >
                              <span
                                className="market-time dateLocalTimeRace"
                                style={{
                                  fontSize: "0.9em",
                                  fontWeight: "bold",
                                  lineHeight: "11px"
                                }}
                              >
                                <span className="dateLocalTimeRaceText">
                                  {moment
                                    .utc(item?.dateTime?.date)
                                    .local()
                                    .format("hh:mm a")}
                                </span>
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "center" }} colSpan={2}>
                              <span
                                style={{
                                  color: "white",
                                  fontSize: "0.9em",
                                  fontWeight: "bold"
                                }}
                              >
                                {item?.venue}({item?.countryCode})
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}
